document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector(".customer-stories-slider")) {
        import(/* webpackChunkName: "customer-stories-block" */ "/Features/CustomerStories/js/customer-stories-block.js").then(async (module) => {
            const customerStorySlider = new module.default();
            await customerStorySlider.init();
        });
    }
});
